export default __webpack_public_path__ + "static/media/mascot-feedback-thumbsup.151166cc.svg";